/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { getBiddingExpired } from 'store/modules/bidding_store/actions';
import Loader from 'components/atoms/loader';
import { BiddingState } from 'store/modules/bidding_store/types';
import 'moment/locale/pt-br';
import colors from 'styles/colors';
import BiddingDate from '../bidding_date';

interface BiddingModalProps {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  bidding: number | null;
}

const BiddingModal = (props: BiddingModalProps) => {
  const dispatch = useDispatch();
  const { showModal, setShowModal, bidding } = props;
  const { biddings, request } = useSelector<ApplicationState, BiddingState>(
    (state) => state.session.biddings,
  );

  useEffect(() => {
    bidding && dispatch(getBiddingExpired(bidding));
  }, [bidding]);

  return (
    <Modal size="lg" show={showModal}>
      <div className="row">
        <div className="col-md-12">
          <div className="modal-content">
            <div className="modal-header" style={{ backgroundColor: colors.$dark_light }}>
              <h5 className="modal-title text-white font-weight-bold">
                Detalhe da licitação: {bidding}
              </h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={() => setShowModal(false)}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {request?.get_bidding_expired?.loading ? (
                <div className="d-flex justify-content-center my-4">
                  <Loader />
                </div>
              ) : request?.get_bidding_expired?.error ? (
                <p className="text-danger text-center my-4">
                  Não foi possível consultar dados dessa licitação.
                </p>
              ) : (
                <>
                  <div className="row">
                    <div className="col-md-12">
                      <p className="font-weight-bold">Objeto</p>
                      <p>{biddings?.bidding_detail?.objeto}</p>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <p className="font-weight-bold">Nº ConLicitação</p>
                      <p>{biddings?.bidding_detail?.id}</p>
                    </div>
                    <div className="col-md-6">
                      <p className="font-weight-bold">Datas</p>
                      {!biddings?.bidding_detail?.datahora_abertura &&
                        !biddings?.bidding_detail?.datahora_prazo &&
                        !biddings?.bidding_detail?.datahora_documento &&
                        !biddings?.bidding_detail?.datahora_retirada &&
                        !biddings?.bidding_detail?.datahora_visita &&
                        'Não Informadas'}
                      {biddings?.bidding_detail?.datahora_abertura && (
                        <BiddingDate
                          date={String(biddings?.bidding_detail?.datahora_abertura)}
                          dateType="Abertura"
                        />
                      )}
                      {biddings?.bidding_detail?.datahora_prazo && (
                        <BiddingDate
                          date={String(biddings?.bidding_detail?.datahora_prazo)}
                          dateType="Prazo"
                        />
                      )}
                      {biddings?.bidding_detail?.datahora_documento && (
                        <BiddingDate
                          date={String(biddings?.bidding_detail?.datahora_documento)}
                          dateType="Documento"
                        />
                      )}
                      {biddings?.bidding_detail?.datahora_retirada && (
                        <BiddingDate
                          date={String(biddings?.bidding_detail?.datahora_retirada)}
                          dateType="Retirada"
                        />
                      )}
                      {biddings?.bidding_detail?.datahora_visita && (
                        <BiddingDate
                          date={String(biddings?.bidding_detail?.datahora_visita)}
                          dateType="Visita"
                        />
                      )}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <p className="font-weight-bold">Edital</p>
                      <p>{biddings?.bidding_detail?.edital}</p>
                    </div>
                    <div className="col-md-6">
                      <p className="font-weight-bold">Processo</p>
                      <p>{biddings?.bidding_detail?.processo}</p>
                    </div>
                  </div>
                  <hr />
                  <div className="row">
                    <div className="col-md-6">
                      <p className="font-weight-bold">Órgão</p>
                      <p>{biddings?.bidding_detail?.orgao_nome}</p>
                    </div>
                    <div className="col-md-6">
                      <p className="font-weight-bold">Cidade</p>
                      <p>
                        {biddings?.bidding_detail?.orgao_cidade} /{' '}
                        {biddings?.bidding_detail?.orgao_estado}
                      </p>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BiddingModal;
